import React from "react";

const AppContext = React.createContext({
    configuration: null,
    startOp: op => op,
    user: null
});

export default AppContext;
